export default __webpack_public_path__ + "static/media/ebanx.fc299cc7.svg";